enum ChartEvents {
  GO_FULLSCREEN = 'goFullscreen',
  OPTION_SELECTED = 'chartOptionSelected',
  RENDERED = 'chartRendered',
  RESET = 'chartOptionReset',
  TIMEZONE_SELECTED = 'timezoneSelected',
  CHART_TYPE_UPDATED = 'updateChartType',
  CHART_GRANULARITY_UPDATED = 'updateChartGranularity',
  SHOW_DAILY_CAP = 'showDailyCap',
}

export default ChartEvents;
